/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CommunityInviteOrDeclineRequest { 
    invitation_status: CommunityInviteOrDeclineRequest.InvitationStatusEnum;
}
export namespace CommunityInviteOrDeclineRequest {
    export type InvitationStatusEnum = 'Approved' | 'Rejected';
    export const InvitationStatusEnum = {
        Approved: 'Approved' as InvitationStatusEnum,
        Rejected: 'Rejected' as InvitationStatusEnum
    };
}